"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function elix(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M7.57278 17.7022L7.57428 17.6992L9.96529 11.9872L7.57278 6.27594L11.9865 11.9872L7.57578 17.6984L7.57278 17.7022ZM16.4048 17.7022L16.4018 17.6984L11.991 11.9872L16.4048 6.27594L14.0123 11.9872L16.4033 17.6992L16.4048 17.7022Z", fill: color }),
        React.createElement("path", { d: "M11.9888 11.9879V15.9674L7.57129 17.6999L11.9888 11.9849V8.00545L16.4063 6.27295L11.9888 11.9879Z", fill: color, fillOpacity: 0.8 }),
        React.createElement("path", { d: "M11.9888 15.9675V19.4557L7.57129 17.6977L11.9888 15.9615V11.988L7.57129 6.27296L11.9888 8.00546V4.51721L16.4063 6.27446L11.9888 8.01071V11.985L16.4063 17.7L11.9888 15.9675Z", fill: color, fillOpacity: 0.5 }),
        React.createElement("path", { d: "M7.57129 6.27446L11.9888 4.51721V8.01071L7.57129 6.27446ZM16.4063 17.6977L11.9888 19.4557V15.9615L16.4063 17.6977Z", fill: color, fillOpacity: 0.145 }),
        React.createElement("path", { d: "M7.58398 17.7157L7.58548 17.7127L9.97649 12.0007L7.58398 6.28949L11.9977 12.0007L7.58698 17.712L7.58398 17.7157ZM16.416 17.7157L16.413 17.712L12.0022 12.0007L16.416 6.28949L14.0235 12.0007L16.4145 17.7127L16.416 17.7157Z", fill: color }),
        React.createElement("path", { d: "M12 12.0015V15.981L7.58249 17.7135L12 11.9985V8.019L16.4175 6.2865L12 12.0015Z", fill: color, fillOpacity: 0.8 }),
        React.createElement("path", { d: "M12 15.981V19.4693L7.58249 17.7113L12 15.975V12.0015L7.58249 6.28651L12 8.01901V4.53076L16.4175 6.28801L12 8.02426V11.9985L16.4175 17.7135L12 15.981Z", fill: color, fillOpacity: 0.5 }),
        React.createElement("path", { d: "M7.58249 6.28801L12 4.53076V8.02426L7.58249 6.28801ZM16.4175 17.7113L12 19.4693V15.975L16.4175 17.7113Z", fill: color, fillOpacity: 0.1 }));
}
exports["default"] = elix;
//# sourceMappingURL=elix.js.map